import { defineRoutes } from "@/service/routing/schema";

const base = "/znizka";

export const discountRoutes = defineRoutes({
  "discount.index": () => `${base}`,
  "discount.show": ({ slug }: { slug: string }) => `${base}/${slug}`,
  infakt: `${base}/zlec-ksiegowosc`,
} as const);
